import { combineEpics } from "redux-observable";

import oauth from "./features/Oauth/oauth.epics";

export default combineEpics(oauth);
